export default __webpack_public_path__ + "static/aritro-1215eba6f81241af5e12bb76712109ad.png";